import React, { useEffect, useRef } from "react";
import "./CompendiumItem.css";
import { X } from "react-feather";
import { BrickInfoTotal } from "../../state/BrickInfoTotal/BrickInfoTotal";
import { IReducer } from "../../state/reducer";
import { useCanvas } from "../GlobalCanvasManager/CanvasContext";
import { getModelPath } from "../../utils/brickModelPaths";
import { getBrickPackForBrick } from "../../utils/brickToBrickPack";

interface CompendiumItemProps extends IReducer {
  id: string;
  hideFound?: boolean;
}

const CompendiumItem: React.FC<CompendiumItemProps> = ({
  id,
  state,
  hideFound = false,
}) => {
  const BrickEntry = state.bricks.get(id);
  const BrickInfo = BrickInfoTotal.get(id);
  const BrickName = BrickInfo?.name;

  // Determine brick source
  let BrickSource = "Action";
  if (BrickInfo?.viaPack) {
    const brickPack = getBrickPackForBrick(id);
    BrickSource = brickPack ? brickPack.title : "Brickpack";
  }

  const visualRef = useRef<HTMLDivElement>(null);
  const { registerCard, unregisterCard } = useCanvas();

  const isFound = BrickEntry && BrickEntry.amount >= 0;

  // Register this card with the global canvas manager
  // Don't register if hideFound is true (to completely hide 3D models)
  useEffect(() => {
    if (!visualRef.current || !isFound || hideFound) return;

    const cardId = `compendium-${id}`;
    const modelPath = getModelPath(id);

    // Get actual dimensions from the DOM element
    const rect = visualRef.current.getBoundingClientRect();

    registerCard({
      id: cardId,
      modelPath,
      element: visualRef.current,
      width: rect.width,
      height: rect.height,
    });

    return () => {
      unregisterCard(cardId);
    };
  }, [id, registerCard, unregisterCard, isFound, hideFound]);

  // Remove default entry
  if (!BrickEntry || BrickEntry.id === "0") return null;

  return (
    <div className="compendiumItem">
      {isFound && !hideFound ? (
        <div className="compendiumVisual" ref={visualRef}></div>
      ) : (
        <div className="compendiumVisual">
          <X size={100} />
        </div>
      )}
      <i className="brickId">{id}</i>
      <div className="compendiumTitle">{BrickName ?? "Title"}</div>
      <div className="compendiumSource">{BrickSource}</div>
    </div>
  );
};

export default CompendiumItem;
